export const ACTIVITY_PLAN_TYPES = [
  { id: 'challenge', title: 'Challenge' },
  { id: 'plan', title: 'Plan' },
]

export const FEATURED_TAG_MAP = {
  trending: 'trending',
  new: 'new',
  popular: 'popular',
  recommended: 'recommended',
}

export const FEATURED_TAGS_STYLES_MAP = {
  trending: { title: 'Trending', bgColor: '#FFD700', color: '#000000' },
  new: { title: 'New', bgColor: '#FFA500', color: '#000000' },
  popular: { title: 'Popular', bgColor: '#FF4500', color: '#000000' },
  recommended: { title: 'Recommended', bgColor: '#FF6347', color: '#000000' },
}

